export default "__VITE_ASSET__DlKodn67__"